import {Component, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { ConditionsService, ICondition } from '../../services/conditions.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-results-list',
  templateUrl: './results-list.component.html',
  styleUrl: './results-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ResultsListComponent implements OnInit {

    @Input() nit: boolean = false;
    @Input() numeroNit: string = '';
    @Input() numDocumento: string = '00000000';
    @Input() name: string = 'PEPE PÉREZ';
    @Input() tipoDocumento: string = 'C. C.';
    @Input() declara: boolean = false;
    @Input() plazo: string = '00/00/0000';
    @Input() conditions!: any;
    @Output() onError = new EventEmitter<boolean>();

    vigencia= new Date().getFullYear()-1;
    showWholeList: boolean = false;
    enableToggler: boolean = true;
    declaraMessage =  `Debe presentar declaración de renta del año gravable ${this.vigencia}.`;
    noDeclaraMessage = `Al parecer, con la información disponible a la fecha, usted no debe declarar renta por el año gravable ${this.vigencia}.`;
    declaraRutMessage = `Debe inscribirse en el RUT y presentar declaración de renta del año gravable ${this.vigencia}. `;
    links: any = {};
    conditionsList: ICondition[] = [];
    private conditionsService = inject(ConditionsService);
    constructor(){
        this.links = environment.enlaces;
    }

    ngOnInit(){
        this.name = this.name.toLowerCase();

        try {
            this.conditionsService.getConditions().subscribe((conditions:ICondition[]) => {
                let totalConditions = 0;
                let checkedConditions = 0;

                this.conditionsList = conditions.map((condition:ICondition) => {
                    totalConditions++;
                    const identNumber = condition.ident;
                    const identValue = this.conditions['ident'+identNumber];
                    condition.checked = identValue;
                    identValue && checkedConditions++;
                    return condition;
                });

                if(totalConditions === checkedConditions || checkedConditions === 0) {
                    this.enableToggler = false;
                }
            });
        } catch (error) {
            this.reportError();
        }
    }

    toggleUnchecked(){
        this.showWholeList = !this.showWholeList;
    }

    reportError(){
        this.onError.emit(true);
    }
}
